"use strict";
exports.__esModule = true;
exports.toCta = void 0;
var utils_1 = require("@lglp/utils");
var fields_1 = require("../fields");
var toCta = function (data, logger) {
    var prismicCta = utils_1.unprefix('cta', data);
    if (prismicCta) {
        return utils_1.compact({
            label: logger.required(fields_1.toText(prismicCta.label)),
            link: logger.required(fields_1.toLink(prismicCta.link, logger))
        });
    }
};
exports.toCta = toCta;
//# sourceMappingURL=cta.js.map